export const sortDataCenters = (
  dataCenters: DataCenterFromApi[],
): DataCenterFromApi[] => {
  return [...dataCenters].sort((dc1, dc2) =>
    dc1.region > dc2.region ? 1 : -1,
  );
};
